<template>
  <div class="AAIntroContainer">
    <div
      :class="{
        'intro-container': true,
        'is-mobile-browser': isMobile && !isIOSApp,
        'is-playing-animation': isPlayingAnimation
      }"
      :style="{ 'background-image': isPlayingAnimation ? '' : backgroundImage }"
    >
      <h1 v-if="!isPlayingAnimation" class="activity-title" transition="fade">
        Assessment Accelerator
      </h1>

      <video
        v-show="isPlayingAnimation"
        id="animation-video"
        playsinline
        ref="AAIntroVideoRef"
        crossorigin="anonymous"
      ></video>
      <video-player-controls
        v-show="isPlayingAnimation"
        :video="moduleVideo"
        :videoReference="this.$refs.AAIntroVideoRef"
      />
      <portal to="next-activity-button">
        <next-activity-button :on-click="handleOnClick" removeTabIndex></next-activity-button>
      </portal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import NextActivityButton from 'components/activity/NextActivityButton.vue';
import AssessmentAcceleratorIntroImg from 'images/assessment-accelerator-intro.png';
import AssetLoader from 'mixins/AssetLoader';
import VideoPlayerControls from '../utils/VideoPlayerControls.vue';

export default {
  props: {
    onComplete: {
      type: Function,
      default: () => {}
    },
    isAssessmentAcceleratorPreview: Boolean
  },

  components: { NextActivityButton, VideoPlayerControls },
  computed: {
    ...mapGetters('activity', ['activityTitle', 'moduleVideo']),
    ...mapState('application', {
      isMobile: state => state.device.isMobile,
      isIOSApp: state => state.device.isIOSApp
    }),
    ...mapState('activity', {
      hasScheduledActivity: state => Boolean(state.data.scheduledActivityId)
    })
  },

  data() {
    return {
      backgroundImage: `url(${AssessmentAcceleratorIntroImg})`,
      isPlayingAnimation: false
    };
  },
  methods: {
    ...mapMutations('application', ['setToolbarMode']),
    handleOnClick() {
      if (this.isAssessmentAcceleratorPreview || this.isPlayingAnimation) {
        this.onComplete();
        return;
      }
      this.isPlayingAnimation = true;
      this.videoRef = this.$refs.AAIntroVideoRef;
      this.videoRef.addEventListener(
        'ended',
        () => {
          this.setToolbarMode(this.hasScheduledActivity ? 'fullScreenOnly' : 'inActivity');
        },
        false
      );
      this.videoRef.play();
      document.querySelector('.pure-button')?.focus();
    }
  },
  mixins: [AssetLoader]
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/fade.scss';

.AAIntroContainer {
  height: 100%;
  overflow: hidden;
  width: 100%;
  position: relative;
}
.intro-container {
  background-position: center !important;
  background-size: cover !important;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: white;

  .activity-title {
    font-size: 48px;
    margin-top: 60px;
    position: absolute;
    text-align: center;
    width: 100%;
  }

  #animation-video {
    position: absolute;
    height: calc(100% - 62px) !important;
    max-width: 100%;
    width: auto !important;
    top: 0;
    z-index: 1000;
  }

  .player-controls-container {
    position: absolute;
    width: 100% !important;
    bottom: 0;
    z-index: 1000;
  }
}

.is-playing-animation {
  background: linear-gradient(to bottom, black 70%, black 100%) !important;
  align-items: center;
  justify-content: center;
  display: flex;
}

.is-mobile-browser {
  max-height: calc(var(--vh, 1vh) * 100) !important;
  max-width: 100vw;
}

.is-chrome-ipad {
  .AAIntroContainer {
    height: calc(var(--vh, 1vh) * 100) !important;
    overflow: hidden;
    width: 100%;
    position: fixed;
    top: 0;
  }

  .activity-title {
    margin-top: 40px;
  }

  .is-playing-animation {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  #animation-video {
    position: fixed;
    height: calc(100% - 62px) !important;
    width: auto !important;
    top: 0;
    z-index: 1000;
  }

  .intro-container {
    height: calc(var(--vh, 1vh) * 100) !important;
    max-height: calc(var(--vh, 1vh) * 100) !important;
    background-position: center;
    width: 100%;
    background-color: white !important;
  }
}
</style>
